export function mapOptional<T,R>(t: T | null | undefined, map: (t: T) => R): R | null | undefined {
    if (t === null) {
        return null;
    }
    if (t === undefined) {
        return undefined;
    }

    return map(t);
}

export function addAll<T>(ts: T[], set: Set<T>): Set<T> {
    ts.forEach(t => set.add(t));
    return set;
}

// https://stackoverflow.com/a/37829643 (scroll only if not visible)
export function scrollIntoViewIfNeeded(target: Element) {
    if (
        target.getBoundingClientRect().bottom > window.innerHeight ||
        target.getBoundingClientRect().top < 0
    ) {
        target.scrollIntoView({
            behavior: "smooth",
            block: "center"
        });
    }
}

export function getImageSize(url: string): Promise<{width: number, height: number}> {
    return new Promise<{width: number; height: number}>(resolve => {
        const img = new Image();
        img.onload = () => {
            resolve({
                width: img.naturalWidth,
                height: img.naturalHeight,
            });
        }

        img.src = url;
    });
}